import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelsComponent } from './hotels.component';
import { HotelsRoutingModule } from './hotels-routing.module';
import { HotelsDataAccessModule } from '../data-access';
import { SearchFormModule } from 'src/app/libs/ui/components/search-form/search-form.module';
import { TicketHeroModule } from 'src/app/libs/ui/components/ticket-hero/ticket-hero.module';
import { LoaderModule } from 'src/app/libs/ui/components/loader/loader.module';

@NgModule({
  declarations: [
    HotelsComponent
  ],
  imports: [
    CommonModule,
    HotelsRoutingModule,
    HotelsDataAccessModule,
    SearchFormModule,
    TicketHeroModule,
    LoaderModule,
  ]
})
export class HotelsModule { }
